import { useFeatureFlagEnabled } from "posthog-js/react";
import { LayoutDrawerV1 } from "./LayoutDrawerV1";
import { LayoutDrawerV2 } from "./LayoutDrawerV2";

export const JASPER_HOTLINE_PHONE_NUMBER = "0652216929";

export interface LayoutDrawerProps {
  onLinkClick?: () => void;
  onClose?: () => void;
}

export const LayoutDrawer = (props: LayoutDrawerProps) => {
  const isThemeV2Enabled = useFeatureFlagEnabled("theme_v2");

  if (isThemeV2Enabled) {
    return <LayoutDrawerV2 {...props} />;
  }

  return <LayoutDrawerV1 {...props} />;
};
